<script setup="">
import { ArchiveIcon, BarChartBigIcon, BellIcon, HomeIcon, StickyNoteIcon } from "lucide-vue-next";
import { computed, ref, watch } from "vue";

import NumberFormat from "@/Components/NumberFormat.vue";
import PreservedScrollRegion from "@/Components/PreservedScrollRegion.vue";

import useNotification from "@/composables/notification";
import { useTeam } from "@/composables/team";
import { useScrollStore } from "@/stores/scroll";
import { Link } from "@inertiajs/vue3";

const scroll = useScrollStore();
const notification = useNotification();
const { team } = useTeam();

const hasNewNotification = ref(false);

const navs = [
  {
    name: "홈",
    icon: HomeIcon,
    href: route("app.campaigns.index", team.value),
    current: route().current("app.campaigns.*"),
    enable: true
  },
  {
    name: "페이지",
    icon: StickyNoteIcon,
    href: route("app.pages.index", team.value),
    current: route().current("app.pages.*"),
    enable: true
  },
  {
    name: "폼",
    icon: ArchiveIcon,
    href: route("app.forms.index", team.value),
    current: route().current("app.forms.*"),
    enable: true
  },
  {
    name: "알림",
    icon: BellIcon,
    href: route("notifications.index", team.value),
    current: route().current("notifications.*"),
    count: computed(() => notification.unreadCount.value),
    enable: true
  },
  {
    name: "통계",
    icon: BarChartBigIcon,
    href: route("app.statistics.team.show", team.value),
    current: route().current("app.statistics.team.*"),
    enable: true
  }
];

watch(
  () => notification.unreadCount.value,
  (value) => {
    hasNewNotification.value = value > 0;
  }
);
</script>

<template>
  <div>
    <div class="spacer h-12 md:hidden"></div>
    <!--end::only-mobile-->

    <PreservedScrollRegion
      v-if="$slots.default"
      id="app-mobile-navbar"
      as="aside"
      class="fixed inset-x-0 bottom-[calc(var(--ios-padding-bottom)+60px)] z-20 h-14 w-full overflow-x-scroll transition scrollbar-hide"
      :class="{
        'translate-y-full': scroll.isDown
      }"
    >
      <slot />
    </PreservedScrollRegion>
    <!--end::sub-menus-->

    <nav class="app-mobile-navbar fixed inset-x-0 bottom-0 z-20 bg-white pb-1 pt-2.5 shadow-soft transition -shadow-y-px dark:bg-deep-900">
      <div class="grid h-full grid-cols-5 place-items-center">
        <div v-for="nav in navs" :key="nav.name" class="transition-all active:scale-95">
          <Link :href="nav.href" class="relative flex flex-col items-center">
            <div class="relative">
              <component
                :is="nav.icon"
                class="h-6 w-6 transition duration-500 focus:outline-none focus:ring-0"
                :class="[nav.current ? 'text-primary' : 'text-500']"
              />
              <span
                v-if="nav.count && nav.count.value > 0"
                class="absolute -right-1 top-0 flex h-4 w-4 min-w-max items-center justify-center rounded-full bg-red-500 text-tiny leading-none text-white"
              >
                <NumberFormat :value="nav.count.value" />
              </span>
            </div>
            <span class="block text-center text-xs" :class="[nav.current ? 'text-primary' : 'text-500']">{{ nav.name }}</span>
          </Link>
        </div>
      </div>
    </nav>
    <!--end::app-menus-->
  </div>
</template>
